import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ProvisionalEstimateResponse } from "../redux/provisional-estimate/type";
import { IApplicantsResponse } from "../types/applicants";

dayjs.extend(utc);
dayjs.extend(timezone);

const defaultSlashFormat = 'DD/MM/YYYY';
const defaultSlashDateTimeFormat = 'DD/MM/YYYY HH:mm:ss'
const defaultFormat = 'YYYY-MM-DD';
const defaultSlashFormatYYYY = 'YYYY/MM/DD';
const defaultDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const separatorSlash = '/';
export const YEAR_LABEL = '年';
export const MONTH_LABEL = '月';
export const DAY_LABEL = '日';
export const monthsInNumericList = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
];
export const daysInNumericList = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31'
];

export const formatDateSlash = (date: string | undefined, time: boolean = true) => {
  return formatDate(date, separatorSlash, time);
}

export const formatDateOnly = (date: string | Date | undefined, separator: string = ''): string => {
  if (!date || !dayjs(date).isValid()) {
    return '';
  }
  const parsedDate = dayjs(date).tz('Asia/Tokyo');
  return separator === separatorSlash ? parsedDate.format(defaultSlashFormat) : parsedDate.format(defaultFormat);
};

export const formatDateOnlyYYYY = (date: string | Date | undefined, separator: string = ''): string => {
  if (!date || !dayjs(date).isValid()) {
    return '';
  }
  const parsedDate = dayjs(date).tz('Asia/Tokyo');
  return separator === separatorSlash ? parsedDate.format(defaultSlashFormatYYYY) : parsedDate.format(defaultFormat);
};


export const formatDate = (date: string | Date | undefined, separator: string = '', time: boolean = true): string => {
  if (!date || !dayjs(date).isValid()) {
    return '';
  }
  const parsedDate = dayjs(date).tz('Asia/Tokyo');

  const hasTime = parsedDate.format('HH:mm:ss') !== '00:00:00';
  if (separator === separatorSlash) {
    return hasTime && time ? parsedDate.format(defaultSlashDateTimeFormat) : parsedDate.format(defaultSlashFormat);
  }
  return hasTime && time ? parsedDate.format(defaultDateTimeFormat) : parsedDate.format(defaultFormat);
};

export const getDateValue = (stringDate: string) => {
  return dayjs(stringDate).toDate();
}

export const getDefaultDateValue = (stringDate: string) => {
  return stringDate === '' ? dayjs().toDate():  dayjs(stringDate).toDate();
}

export const getTomorrowDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  return date;
}

export const getYesterdayDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
}

export const constructStartDateFromEstimate = (estimate: ProvisionalEstimateResponse | null) => {
  return estimate ? constructDate(estimate?.schoolStartYear || '', estimate?.schoolStartMonth || '', estimate?.schoolStartDay || '') : '';
}

export const constructEndDateFromEstimate = (estimate: ProvisionalEstimateResponse | null) => {
  return estimate ? constructDate(estimate?.schoolEndYear || '', estimate?.schoolEndMonth || '', estimate?.schoolEndDay || '') : '';
}

export const constructDate = (year: string | undefined, month: string | undefined, day: string | undefined) => {
  if (!year || !month || !day) return "";
  return `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
};

export const parseDateFromParts = (
  year: string | undefined | null,
  month: string | undefined | null,
  day: string | undefined | null
): Date | null => {
  if (year == null || month == null || day == null) return null;
  const dateStr = constructDate(year, month, day);
  if (!dateStr) return null;
  const date = getDateValue(dateStr);
  return dayjs(date).isValid() ? date : null;
};

export const getStartDate = (application: IApplicantsResponse): Date | null => {
  const year = application.schoolStartYear ?? (application as any).applicationStartYear;
  const month = application.schoolStartMonth ?? (application as any).applicationStartMonth;
  const dayRaw = application.schoolStartDay ?? (application as any).applicationStartDay;
  const day = dayRaw === '未定' ? '1' : dayRaw;
  return parseDateFromParts(year, month, day);
};
